import { AssetsColors } from "@/constants/style.constants";
import { AssetType } from "@/states/path_param/path_param.decl";
import { AUDIO_PLAYER_ERROR } from "./Player.constants";

const MAX_SRC_FETCH_RETRIES = 3;

export const AssetColorsMapper: { [key in AssetType]: AssetsColors } = {
  recording: "green",
  voicemail: "yellow",
};

export const shouldFetchSrc = (error: MediaError | null, retries: number) =>
  retries < MAX_SRC_FETCH_RETRIES &&
  (error?.message === AUDIO_PLAYER_ERROR.RENDER ||
    error?.message === AUDIO_PLAYER_ERROR.DATA_SOURCE);
